import { Component } from 'react'
import ReactDOM from 'react-dom'
import Button from '../../Nodes/Button'
import { Body1 } from '../../Nodes/Typography'

class Notification extends Component {
    hiddenClass = 'notification--hidden'

    constructor(props) {
        
        super(props)
        this.containerEl = document.createElement('div')
        this.containerEl.classList.add('notification')
        this.containerEl.classList.add(this.hiddenClass)
    }

    renderNotification() {
        const { children, onClose } = this.props

        return (
            <div className="notification__content">
                <Body1 dangerouslySetInnerHTML={{ __html: children }} />
                <Button outlined onClick={onClose}>OK</Button>
            </div>
        )
    }

    render() {
        const { open } = this.props

        open ? 
            this.containerEl.classList.remove(this.hiddenClass) :
            this.containerEl.classList.add(this.hiddenClass)

        return ReactDOM.createPortal(
            this.renderNotification(),
            this.containerEl)

    }

    componentDidMount() {
        document.body.appendChild(this.containerEl)
    }

    componentWillUnmount() {
        document.body.removeChild(this.containerEl)
    }
}

export default Notification